var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5327 17.5012C10.553 18.4258 9.00898 18.4087 8.0501 17.4498C7.07379 16.4735 7.07379 14.8906 8.0501 13.9142L15.8283 6.13607C16.0235 5.94081 16.3401 5.94081 16.5354 6.13607C16.7306 6.33133 16.7306 6.64792 16.5354 6.84318L8.75721 14.6214C8.17142 15.2071 8.17142 16.1569 8.75721 16.7427C9.343 17.3285 10.2927 17.3285 10.8785 16.7427L18.6567 8.9645C20.0235 7.59766 20.0235 5.38159 18.6567 4.01475C17.2899 2.64792 15.0738 2.64792 13.707 4.01475L5.92878 11.7929C3.7809 13.9408 3.7809 17.4232 5.92878 19.5711C8.07667 21.719 11.5591 21.719 13.707 19.5711L20.0709 13.2071C20.2662 13.0119 20.5828 13.0119 20.778 13.2071C20.9733 13.4024 20.9733 13.719 20.778 13.9142L14.4141 20.2782C11.8757 22.8166 7.76009 22.8166 5.22168 20.2782C2.70067 17.7572 2.68339 13.6806 5.16983 11.1382L12.9999 3.30764C14.7572 1.55028 17.6065 1.55028 19.3638 3.30764C21.1212 5.065 21.1212 7.91425 19.3638 9.6716L11.5335 17.5019L11.5327 17.5012Z",
    fill: "#0062ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinPrimary);
export default __webpack_public_path__ + "static/media/PinPrimary.f02e80f3a1a22f61b1bab2a89722e61e.svg";
export { ForwardRef as ReactComponent };